import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import FAQPage from './pages/FAQPage';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import LegalPage from './pages/LegalPage';
import SEOManager from './components/SEOManager';
const ScrollToTop=()=>{const{pathname}=useLocation();useEffect(()=>{window.scrollTo({top:0,behavior:'auto'});},[pathname]);return null;};
function App(){return <div className="App"><BrowserRouter><ScrollToTop/><SEOManager/><Routes><Route path="/" element={<Home/>}/><Route path="/services" element={<ServicesPage/>}/><Route path="/services/:serviceSlug" element={<ServiceDetailPage/>}/><Route path="/about" element={<About/>}/><Route path="/insights" element={<Blog/>}/><Route path="/blog" element={<Navigate to="/insights" replace/>}/><Route path="/blog/:slug" element={<BlogPost/>}/><Route path="/faq" element={<FAQPage/>}/><Route path="/contact" element={<Contact/>}/><Route path="/legal/:policy" element={<LegalPage/>}/><Route path="*" element={<Navigate to="/" replace/>}/></Routes></BrowserRouter></div>}
export default App;
